import * as ActionConfigurationManager from './config.actions';

export const validateDealer = ActionConfigurationManager.VALIDATE_DEALER;
export const validateDealerSuccess = ActionConfigurationManager.VALIDATE_DEALER_SUCCESS;
export const validateDealerError = ActionConfigurationManager.VALIDATE_DEALER_ERROR
export const rehydrateDealer = ActionConfigurationManager.REHYDRATE_DEALER
export const resetDealer = ActionConfigurationManager.RESET_DEALER
export const previewDealer = ActionConfigurationManager.PREVIEW_DEALER;
export const previewDealerSuccess = ActionConfigurationManager.PREVIEW_DEALER_SUCCESS;
export const previewDealerError = ActionConfigurationManager.PREVIEW_DEALER_ERROR;
